import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenSeedlingFetchAction from './communityGardenSeedlingFetch.action.json' with { type: 'json' }
import { communityGardenSeedlingObject } from '../../communityGardenSeedlingObject'

const communityGardenSeedlingFetchDefinition = defineAction({
  ...communityGardenSeedlingFetchAction,

  input: z.object({
    id: communityGardenSeedlingObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: communityGardenSeedlingObject,
})

export default communityGardenSeedlingFetchDefinition
